
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5942',
  depVersions: {
  "data-privacy-request-ui": "static-1.5942",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10063",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8456",
  "hub-http-shared-msw-handlers": "static-1.10807",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11908",
  "I18n": "static-7.1692",
  "jasmine-runner": "static-1.6867",
  "quartz": "static-1.7590",
  "react-dlb": "static-1.92",
  "rpc-client-utils": "static-1.5087",
  "ui-components-test-utils": "static-1.6045",
  "UIComponents": "static-3.8854",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.98",
  "foundations-assets": "static-1.5303",
  "foundations-components": "static-1.8658",
  "foundations-components-test-utils": "static-1.6141",
  "foundations-theming": "static-1.4899",
  "hub-http": "static-1.6626",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1368",
  "quartz-core": "static-1.6809",
  "quartz-routing": "static-1.1020",
  "quick-fetch": "static-1.4194",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11564",
  "usage-tracker": "static-1.7731",
  "usage-tracker-anonymous": "static-1.6148",
  "usage-tracker-core": "static-1.7581",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3867",
  "quartz-webpack": "static-1.3814",
  "bend-plugin-quartz-routing": "static-1.668",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "HeadJS": "static-2.812",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3567",
  "msw": "static-1.39",
  "msw-config": "static-1.19",
  "testing-library": "static-1.163",
  "ts-schema": "static-1.4363",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "react-utils": "static-2.5626",
  "StyleGuideUI": "static-3.513",
  "jasmine": "static-4.4726",
  "bend-plugin-chirp-manifest": "static-1.497",
  "chirp-fetch": "static-1.2318",
  "HubStyle": "static-2.12215",
  "ui-addon-draggable": "static-3.5163",
  "cssUtils": "static-1.1039",
  "hs-story-utils": "static-1.9842",
  "icons": "static-2.699",
  "react-create-root-preference": "static-1.89",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-components": "static-1.4927",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2615",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2952",
  "ui-fonts": "static-1.1170",
  "foundations-components-legacy": "static-1.1683",
  "bend-plugin-foundations-theming": "static-1.3382",
  "foundations-theming-base": "static-1.3884",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.364",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.897",
  "hubspotter-http": "static-1.4931",
  "mobile-manifest-mixins": "static-1.595",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1265",
  "quartz-head": "static-1.1255",
  "quartz-i18n": "static-1.1265",
  "quartz-test": "static-1.1265",
  "quartz-tracking": "static-1.969",
  "trellis-components": "static-1.2971",
  "usage-tracker-container": "static-1.7721",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3518",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.117",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.82",
  "sassPrefix": "static-1.306",
  "stylex-utils": "static-1.160",
  "trellis-theming": "static-1.1401",
  "hubspotter-http-shared-msw-handlers": "static-1.10805",
  "usage-tracker-session-replay": "static-1.5417",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5942",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10063",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8456",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10807",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11908",
  "I18n": "/I18n/static-7.1692",
  "jasmine-runner": "/jasmine-runner/static-1.6867",
  "quartz": "/quartz/static-1.7590",
  "react-dlb": "/react-dlb/static-1.92",
  "rpc-client-utils": "/rpc-client-utils/static-1.5087",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6045",
  "UIComponents": "/UIComponents/static-3.8854",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "foundations-assets": "/foundations-assets/static-1.5303",
  "foundations-components": "/foundations-components/static-1.8658",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6141",
  "foundations-theming": "/foundations-theming/static-1.4899",
  "hub-http": "/hub-http/static-1.6626",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1368",
  "quartz-core": "/quartz-core/static-1.6809",
  "quartz-routing": "/quartz-routing/static-1.1020",
  "quick-fetch": "/quick-fetch/static-1.4194",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11564",
  "usage-tracker": "/usage-tracker/static-1.7731",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6148",
  "usage-tracker-core": "/usage-tracker-core/static-1.7581",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3867",
  "quartz-webpack": "/quartz-webpack/static-1.3814",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.668",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "HeadJS": "/HeadJS/static-2.812",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3567",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.19",
  "testing-library": "/testing-library/static-1.163",
  "ts-schema": "/ts-schema/static-1.4363",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "react-utils": "/react-utils/static-2.5626",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "jasmine": "/jasmine/static-4.4726",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.497",
  "chirp-fetch": "/chirp-fetch/static-1.2318",
  "HubStyle": "/HubStyle/static-2.12215",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5163",
  "cssUtils": "/cssUtils/static-1.1039",
  "hs-story-utils": "/hs-story-utils/static-1.9842",
  "icons": "/icons/static-2.699",
  "react-create-root-preference": "/react-create-root-preference/static-1.89",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4927",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2615",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2952",
  "ui-fonts": "/ui-fonts/static-1.1170",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1683",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3382",
  "foundations-theming-base": "/foundations-theming-base/static-1.3884",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.364",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.897",
  "hubspotter-http": "/hubspotter-http/static-1.4931",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.595",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1265",
  "quartz-head": "/quartz-head/static-1.1255",
  "quartz-i18n": "/quartz-i18n/static-1.1265",
  "quartz-test": "/quartz-test/static-1.1265",
  "quartz-tracking": "/quartz-tracking/static-1.969",
  "trellis-components": "/trellis-components/static-1.2971",
  "usage-tracker-container": "/usage-tracker-container/static-1.7721",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.117",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.82",
  "sassPrefix": "/sassPrefix/static-1.306",
  "stylex-utils": "/stylex-utils/static-1.160",
  "trellis-theming": "/trellis-theming/static-1.1401",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10805",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5417",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
